import React, { useEffect } from "react";
import DashboardButtons from "../Granja/DashboardButtons/DashboardButtons";
import GranjasTable from "./GranjasTable/GranjasTable"
import "./Granja.css";
import { useShoppingContext } from "../context/ShoppingContext";

const MisGranjas = () => {
  const {
    fetchMisGranjas,
    fetchMisGalpones,
    fetchMisAves,
    fetchProduccionHuevos,
    fetchAlimentos,
    isDarkMode,
  } = useShoppingContext();

  useEffect(() => {
    fetchProduccionHuevos();
    fetchMisGranjas();
    fetchMisGalpones();
    fetchMisAves();
    fetchAlimentos();
  }, [
    fetchProduccionHuevos,
    fetchAlimentos,
    fetchMisGranjas,
    fetchMisGalpones,
    fetchMisAves,
  ]);

  return (
    <div className={isDarkMode ? "content-container" : "content-container light"}>
      <DashboardButtons />
      <GranjasTable />
    </div>
  );
};

export default MisGranjas;
